<script lang="ts">
  import { dayjs } from '../../lib/dayjs';
  import { onDestroy, onMount } from 'svelte';
  import VerifyAndApprove from './verify-and-approve.svelte';
  import RejectionReasonModal from '../_shared/RejectionReasonModal.svelte';
  import { debugLog } from '../../lib/debug-log';
  import { getAuthHeaders } from '../../lib/authHeaders';
  import { ALL_CRITERIA_FIELDS } from '../../lib/agentTransformations';

  let row = null;
  let URL = `${process.env.SVELTE_APP_REMOTE_URL}/api`;
  let purchasereceipts = [];

  const mountAdminView = () => {
    document.getElementById('verification').innerHTML = '';

    import('App/Purchasepaybacks').then((m) => {
      let module = m.default;

      new module({
        target: document.getElementById('verification'),
        layout: 'auto',
        props: {
          dateFormat: 'DD.MM.YYYY - HH:mm',
          filter: {
            limit: 10,
            where: {
              and: [
                {
                  completed: 1,
                  purchasereceiptsId: {
                    inq: purchasereceipts,
                  },
                },
              ],
            },
          },
          defaultFilter: {
            status: 'APPROVED',
          },
          schema: {
            'field-properties': {
              'field-order': [
                'id',
                'date',
                'completed',
                'status',
                'cashbackType',
                'personalinformation',
                'purchasereceipts',
                'questions',
              ],
              'field-transformation': [
                {
                  name: 'date',
                  transformation: (value) => {
                    return dayjs(value)
                      .tz('Europe/Berlin')
                      .locale('de-DE')
                      .format('DD.MM.YYYY - HH:mm');
                  },
                },
              ],
              'auto-generated-fields': ['id'],
              'boolean-fields': [
                'completed',
                'personalinformationOverride',
                'archived',
                'ibanVerified',
                'phoneVerified',
                'addressVerified',
                'dealerOverride',
                'partsOverrride',
                'purchaseDateOverride',
                'storageOverride',
                'switchOverride',
              ],
              'hidden-fields': [
                'rejectionReason',
                'paidDate',
                'paidByMbdDate',
                ...ALL_CRITERIA_FIELDS,
              ],
              'readonly-fields': [
                'id',
                'purchasereceipts',
                'purchasereceiptsId',
                'personalinformation',
                'personalinformationId',
                ...ALL_CRITERIA_FIELDS,
              ],
              'relational-fields': [
                {
                  name: 'personalinformation',
                  editable: true,
                  // columns: ["id", "name", "vorname", "geburtstag", "notizen"],
                },
                {
                  name: 'purchasereceipts',
                  editable: true,
                  // columns: ["id", "name", "vorname", "geburtstag", "notizen"],
                },
              ],
              'dropdown-fields': [
                {
                  name: 'status',
                  default: {
                    label: 'VERIFICATION',
                    value: 'VERIFICATION',
                  },
                  options: [
                    {
                      label: 'INCOMPLETE',
                      value: 'INCOMPLETE',
                    },
                    {
                      label: 'REJECTED',
                      value: 'REJECTED',
                    },
                    {
                      label: 'VERIFICATION',
                      value: 'VERIFICATION',
                    },
                    {
                      label: 'PRE-APPROVED',
                      value: 'PRE-APPROVED',
                    },
                    {
                      label: 'APPROVED',
                      value: 'APPROVED',
                    },
                    {
                      label: 'PRE-PAYMENT',
                      value: 'PRE-PAYMENT',
                    },
                    {
                      label: 'PAID',
                      value: 'PAID',
                    },
                    {
                      label: 'PARKING1',
                      value: 'PARKING1',
                    },
                    {
                      label: 'PARKING2',
                      value: 'PARKING2',
                    },
                    {
                      label: 'PARKING3',
                      value: 'PARKING3',
                    },
                    {
                      label: 'PARKING4',
                      value: 'PARKING4',
                    },
                    {
                      label: 'PARKING5',
                      value: 'PARKING5',
                    },
                  ],
                },
                {
                  name: 'cashbackType',
                  default: {
                    label: 'cashback-basic',
                    value: 'cashback-basic',
                  },
                  options: [
                    {
                      label: 'cashback-basic',
                      value: 'cashback-basic',
                    },
                    {
                      label: 'cashback-full',
                      value: 'cashback-full',
                    },
                  ],
                },
              ],
              'json-fields': [
                {
                  field: 'address',
                  template: '${street}, ${zip} ${city}',
                },
              ],
            },
            'custom-bulk-actions': [
              //   {
              //     action: "Incomplete",
              //     bulkFn: async (rows) => {
              //       const promises = rows.map((row) => {
              //         return new Promise((resolve) => {
              //           const event = new CustomEvent("updateRow", {
              //             detail: {
              //               rowId: row,
              //               fields: {
              //                 status: "INCOMPLETE",
              //               },
              //             },
              //           });
              //           window.dispatchEvent(event);
              //           resolve();
              //         });
              //       });

              //       return promises;
              //     },
              //     singleFn: (row) => {
              //       const event = new CustomEvent("updateRow", {
              //         detail: {
              //           rowId: row.id,
              //           fields: {
              //             status: "INCOMPLETE",
              //           },
              //         },
              //       });
              //       window.dispatchEvent(event);
              //       // return selectedids;
              //     },
              //   },
              {
                action: 'Approve',
                bulkFn: async (rows) => {
                  const promises = rows.map(async (row) => {
                    const getResponse = await fetch(
                      `${URL}/purchasepaybacks/${row}`,
                      {
                        method: 'GET',
                        headers: getAuthHeaders(),
                      },
                    );
                    const response = await getResponse.json();
                    return new Promise((resolve) => {
                      const event = new CustomEvent('updateRow', {
                        detail: {
                          rowId: row,
                          fields: {
                            status: 'APPROVED',
                            approvedDate:
                              response.approvedDate &&
                              response.approvedDate !== 'Invalid Date'
                                ? undefined
                                : new Date().toISOString(),
                          },
                        },
                      });

                      window.dispatchEvent(event);
                      requestAnimationFrame(() => resolve(undefined));
                    });
                  });
                  return Promise.all(promises);
                },
                singleFn: (row) => {
                  const event = new CustomEvent('updateRow', {
                    detail: {
                      rowId: row.id,
                      fields: {
                        status: 'APPROVED',
                        approvedDate:
                          row.approvedDate &&
                          row.approvedDate !== 'Invalid Date'
                            ? undefined
                            : new Date().toISOString(),
                      },
                    },
                  });
                  window.dispatchEvent(event);
                  // return selectedids;
                },
              },
              {
                action: 'Reject',
                bulkFn: async (rows) => {
                  const promises = rows.map((row) => {
                    return new Promise((resolve) => {
                      const event = new CustomEvent('updateRow', {
                        detail: {
                          rowId: row,
                          fields: {
                            status: 'REJECTED',
                          },
                        },
                      });
                      window.dispatchEvent(event);
                      resolve();
                    });
                  });

                  return promises;
                },
                singleFn: (row) => {
                  rowInstance = row;
                  rejectionReasonModalOpen = true;
                  // return selectedids;
                },
              },
              {
                action: 'Verify and Approve',
                singleFn: (row) => {
                  const event = new CustomEvent('approve', { detail: row });
                  window.dispatchEvent(event);
                  // return selectedids;
                },
              },
            ],
          },
        },
      });
    });
  };

  const updateRow = async (rowId, fields) => {
    await fetch(`${URL}/purchasepaybacks/${rowId}`, {
      method: 'PATCH',
      headers: getAuthHeaders(),
      body: JSON.stringify(fields),
    });
    mountAdminView();
  };

  onMount(async () => {
    const purchasereceiptsRequest = await fetch(
      `${URL}/purchasereceipts?filter={"where":{"dealershipsId":null}}`,
      {
        method: 'GET',
        headers: getAuthHeaders(),
      },
    );

    purchasereceipts = (await purchasereceiptsRequest.json()).map((p) => p.id);

    debugLog(purchasereceipts);

    mountAdminView();
    // listen to the updateRow event in the global context
    // and update the state of the child component
    window.addEventListener('updateRow', (e) => {
      updateRow(e.detail.rowId, e.detail.fields);
    });
  });

  onDestroy(() => {
    // remove the event listener
    window.removeEventListener('updateRow', (e) => {
      debugLog(e.detail);
    });
  });

  let rowInstance = null;
  let rejectionReason = '';
  let rejectionReasonModalOpen = false;

  const closeModal = () => (rejectionReasonModalOpen = false);

  const confirmRejection = async () => {
    const event = new CustomEvent('updateRow', {
      detail: {
        rowId: rowInstance.id,
        fields: {
          status: 'REJECTED',
          rejectionReason,
        },
      },
    });
    window.dispatchEvent(event);
    closeModal();
  };
</script>

<!-- Adobe Embed API -->
<!-- <svelte:head>
  <script src="https://acrobatservices.adobe.com/view-sdk/viewer.js"></script>
</svelte:head> -->

<RejectionReasonModal
  bind:inputValue={rejectionReason}
  submitFunction={confirmRejection}
  bind:open={rejectionReasonModalOpen}
/>

<VerifyAndApprove {mountAdminView} bind:row />

<div id="verification" />
